import { match } from 'ts-pattern'
import { useIsMobile } from '../../../hooks/use-mobile'
import { cn } from '../../../lib'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../shadcn/dialog'
import { Drawer, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle } from '../../shadcn/drawer'
import { useDialogStore } from './dialogStore'

export const DialogProvider = () => {
  const title = useDialogStore((state) => state.title)
  const description = useDialogStore((state) => state.description)
  const content = useDialogStore((state) => state.content)
  const isOpen = useDialogStore((state) => state.show)
  const layout = useDialogStore((state) => state.layout)
  const setIsOpen = useDialogStore((state) => state.setShow)
  const size = useDialogStore((state) => state.size)
  const hideCloseButton = useDialogStore((state) => state.hideCloseButton)
  const isMobile = useIsMobile()

  const dialogContent = match(layout)
    .with('content-only', () => (
      <DialogContent
        hideCloseButton={hideCloseButton}
        className={cn(size ?? 'max-w-2xl', 'p-0 border-0 dark:bg-neutral-100 gap-0 focus-visible:outline-hidden')}
      >
        {content}
      </DialogContent>
    ))
    .with('custom', () => (
      <DialogContent
        className={cn(size ?? 'max-w-2xl', 'max-h-screen gap-0 py-0 px-6 dark:bg-neutral-100')}
        hideCloseButton={hideCloseButton}
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>
        {content}
      </DialogContent>
    ))
    .otherwise(() => (
      <DialogContent className={cn(size ?? 'max-w-2xl', ' dark:bg-neutral-100')} hideCloseButton={hideCloseButton}>
        {(title || description) && (
          <DialogHeader className="space-y-4">
            <DialogTitle className="text-foreground">{title}</DialogTitle>
            {description && (
              <DialogDescription className="text-sm text-muted-foreground">{description}</DialogDescription>
            )}
          </DialogHeader>
        )}
        <div className="text-sm text-muted-foreground">{content}</div>
      </DialogContent>
    ))

  const drawerContent = match(layout)
    .with('content-only', () => (
      <DrawerContent className={cn('p-0 border-0 bg-neutral-50 gap-0')}>{content}</DrawerContent>
    ))
    .with('custom', () => (
      <DrawerContent className={cn('max-h-screen gap-0 py-0 px-6')}>
        <DrawerTitle className="sr-only">{title}</DrawerTitle>
        {content}
      </DrawerContent>
    ))
    .otherwise(() => (
      <DrawerContent>
        <DrawerHeader className="space-y-4">
          <DrawerTitle className="text-foreground">{title}</DrawerTitle>
          {description && (
            <DrawerDescription className="text-sm text-muted-foreground">{description}</DrawerDescription>
          )}
        </DrawerHeader>
        <div className="text-sm text-muted-foreground px-4 pb-4">{content}</div>
      </DrawerContent>
    ))

  if (isMobile) {
    return (
      <Drawer open={isOpen} onOpenChange={setIsOpen} direction="bottom">
        {drawerContent}
      </Drawer>
    )
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      {dialogContent}
    </Dialog>
  )
}
